import styled from '@emotion/styled'

export const StyleColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`
export const StyleCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  @media (max-width: 800px) {
    flex-flow: row wrap;
    row-gap: 20px;
  }
`

export const StyleLeftWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  aling-items: center;
  @media (max-width: 767px) {
    width: 100%;
  }
`
export const StyleRightWrapper = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
  @media (max-width: 767px) {
    flex-flow: row wrap;
    row-gap: 10px;
  }
`
export const StyleTag = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.white100};
  padding: 5px 7px;
  border-radius: 4px;
  display: flex;
  column-gap: 5px;
  font-size: 12px;
  align-items: center;
  color: ${(props: any) => props.theme.colors.text};
`
